export interface PressAndHoldRepeater {
  isRunning: () => boolean;
  start: (action: () => boolean) => void;
  stop: () => void;
}

interface PressAndHoldRepeaterOptions {
  initialDelayMs?: number;
  repeatDelayMs?: number;
}

export const createPressAndHoldRepeater = ({
  initialDelayMs = 350,
  repeatDelayMs = 80,
}: PressAndHoldRepeaterOptions = {}): PressAndHoldRepeater => {
  let action: (() => boolean) | undefined;
  let running = false;
  let timeout: ReturnType<typeof setTimeout> | undefined;

  const stop = (): void => {
    running = false;
    action = undefined;

    if (timeout !== undefined) {
      clearTimeout(timeout);
      timeout = undefined;
    }
  };

  const repeat = (): void => {
    timeout = undefined;

    if (!running || !action || !action()) {
      stop();

      return;
    }

    timeout = setTimeout(repeat, repeatDelayMs);
  };

  return {
    isRunning: () => running,
    start: nextAction => {
      stop();
      action = nextAction;
      running = true;
      timeout = setTimeout(repeat, initialDelayMs);
    },
    stop,
  };
};
